export default (element: HTMLElement) => {
  // Get configuration from data attributes
  const tabActiveClass = element.dataset.tabActiveClass;
  const contentHiddenClass = element.dataset.contentHiddenClass;

  if (!tabActiveClass) {
    console.error('Missing data-tab-active-class attribute on tabs component');
    return;
  }

  if (!contentHiddenClass) {
    console.error(
      'Missing data-content-hidden-class attribute on tabs component',
    );
    return;
  }

  // Find all tab buttons and content sections
  const tabButtons =
    Array.from(element.children)
      .find((child) => child.hasAttribute('data-tab-tabs'))
      ?.querySelectorAll<HTMLElement>('[data-tab-name]') ?? [];
  if (tabButtons.length === 0) {
    console.error(
      'No tab buttons found with [data-tab-name] attribute inside [data-tab-tabs]',
    );
    return;
  }

  const contentSections = Array.from(element.children).filter((child) =>
    child.hasAttribute('data-tab-content-name'),
  ) as HTMLElement[];
  if (contentSections.length === 0) {
    console.error(
      'No content sections found with [data-tab-content-name] attribute',
    );
    return;
  }

  // Validate that each tab has corresponding content
  const tabNames = Array.from(tabButtons).map((btn) => btn.dataset.tabName);
  const contentNames = Array.from(contentSections).map(
    (section) => section.dataset.tabContentName,
  );

  tabNames.forEach((name) => {
    if (!contentNames.includes(name)) {
      console.warn(
        `Tab "${name}" has no corresponding content section with data-tab-content-name="${name}"`,
      );
    }
  });

  // Handle tab clicks
  const switchTab = (tabName: string) => {
    // Update tab buttons
    tabButtons.forEach((button) => {
      if (button.dataset.tabName === tabName) {
        button.classList.add(tabActiveClass);
      } else {
        button.classList.remove(tabActiveClass);
      }
    });

    // Update content sections
    contentSections.forEach((section) => {
      if (section.dataset.tabContentName === tabName) {
        section.classList.remove(contentHiddenClass);
      } else {
        section.classList.add(contentHiddenClass);
      }
    });
  };

  // Add click listeners to all tab buttons
  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tabName = button.dataset.tabName;
      if (tabName) {
        switchTab(tabName);
      }
    });
  });
};
